import React from "react";
import Modal from "Components/smallModal/smallModal";
import Pin from "Components/pin/Pin";
import Button from "Components/button/Button";
import request from "../../config";
import PropTypes from "prop-types";
import { alertSuccess, alertError } from "Utils/alerts";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";

import s from "./otpModal.scss";

const propTypes = {
  opened: PropTypes.bool,
  handleClose: PropTypes.func,
  handleCodeVerification: PropTypes.func,
  setSession: PropTypes.func,
  isFormSubmitting: PropTypes.bool
};

class OtpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerifing: false
    };
  }

  loginUser(resp) {
    const loggedUser = resp.data.resources[0];
    this.props.setSession(loggedUser);
  }

  verifyCode(e) {
    e.preventDefault();
    this.setState({ isVerifing: true });
    const otp = this.pin.getValue();

    if (this.props.verifyOnly) {
      this.props.verifyOTP(this.props.userCode, { otp });
      return;
    }
    // this code execute only when the modal is used to log in
    const config = {
      method: "POST",
      url: `/users/${this.props.userCode}/otp/verify/login`,
      data: { otp, remember_device: this.props.remember_device }
    };

    request(config)
      .then(resp => {
        alertSuccess(t("alert.otpValid"));
        if (this.props.verifyOnly) {
        } else {
          this.loginUser(resp);
        }
      })
      .catch(e => {
        if (e.response.status === 422) {
          alertError(t("alert.otpInvalid"));
          this.setState({ isVerifing: false });
        } else if (e instanceof Error) throw e;
      });
  }
  render() {
    const { opened, handleClose, onCancel } = this.props;
    return (
      <Modal title={t("modal.otp.access.title")} opened={opened} closeModal={handleClose} withForm>
        <form className={s.form} method="post" onSubmit={this.verifyCode.bind(this)}>
          <div className={s.wrapInputs}>
            <div>
              <TranslatedString>modal.otp.access.desc</TranslatedString>
            </div>
            <Pin className={s.pin} ref={pin => (this.pin = pin)} length={6} />
          </div>
          <div className={s.footerBtn}>
            <Button
              onClick={onCancel}
              type="button"
              loading={this.state.isVerifing || this.props.isVerifing}
              color="text"
            >
              button.cancel
            </Button>
            <Button loading={this.state.isVerifing || this.props.isVerifing}>button.verify</Button>
          </div>
        </form>
      </Modal>
    );
  }
}
//OtpModal.propTypes = propTypes;
export default OtpModal;
